var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path2, _g11, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDsmSimplifiedLogoReversed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 667.48 324.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(-829.61 -1521 -1521 829.61 2192.5 2190.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ad0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f89c0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#bb1f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb1f84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(0 1436.7 1436.7 0 991.46 43.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85cf48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#69c645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#118249"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(-1015.8 1015.8) rotate(44 -1.247 -1.679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#45c0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#00a384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "matrix(0 -1002.1 -1002.1 0 1026.1 1361)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#00966c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00966c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(1668.87 -1668.87) rotate(75 1.169 -.416)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75d3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#75d3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#4dc6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dc6f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "scale(1466.28 -1466.28) rotate(80 1.075 -.378)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#069be2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#069be2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#254aa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b3679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(0 810.74 810.74 0 1598.7 988.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2f7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a98164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "scale(1451.6 -1451.6) rotate(30 2.692 -.126)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d8ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283c97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x2: 1,
    gradientTransform: "scale(-542.4 542.4) rotate(59.56 -2.004 -2.073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d55cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96168f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x2: 1,
    gradientTransform: "scale(-338.4 338.4) rotate(59.56 -4.104 -3.212)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab288b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#951983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x2: 1,
    gradientTransform: "matrix(828.25 0 0 -828.25 626.98 663.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e388b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a3ea4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1972.8 2310.4c-277.75-83.11-410.25-212.51-368.81-570.64 34.1-235.2 14.16-434.83-20.78-569.56-7.46-28.89-14.84-52.05-22.44-72.2-2.29-8.17-5.35-16.37-9.33-24.53-21-43.28-67.91-134.45-89.57-168.56-16.3-25.86-56.34-67.809-106.51-67.36-48.64.371-154.92 4.258-182.5 4.258-26.43 0-75.41-3.008-75.41-3.008 70.84-76.25 194.81-145.7 361.99-147.36 124.62-1.289 265.38 34.059 400.04 130.7 488.88 350.55 367.5 1243.7 113.32 1488.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956.35 1446.6c-343.54-107.64-521.49-530.72-370.02-954.88 12.129-34.121 26.348-68.128 42.891-102.13 211.81-435.31 633.38-336.11 633.38-336.11s152.56 288.61-129.14 512.63c-196.7 156.49-298.95 312.7-204.24 557.01 5 12.95 11.008 26.32 17.363 39.82 1.027 2.38 2.051 4.95 3.301 7.51 32.812 71.86 82.207 143.6 112.49 187.64 20.54 29.81 44.63 44.4 97.92 48.92 49.52 4.16 167.75 1.53 199.44-.87 45.9-3.72 65.92-11.16 89.6-46.65.53-.92 1.1-1.72 1.69-2.62-67.8 126.11-285.63 155.19-494.67 89.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1190.2 837.3c-35.77 4.758-65.41 4.488-83.95 11.578l-.16.23c-16.22 6.063-31.38 16.922-44.37 36.012-29.45 43.32-87.813 143.54-108.16 185.07-21.98 44.74-19.988 64.7-3.769 100.27 32.929 71.86 82.364 143.6 112.6 187.55.72 1.02 1.46 2.11 2.14 3.05-14.26-12.19-131.52-113.25-209.1-220-142.78-196.48-103.44-467.96 59.18-636.4 118.93-123.15 257.99-148.48 364.12-145.53 194.91 5.351 373.79 158.44 373.79 158.44-63.89 187.77-245.61 291.4-462.32 319.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1278.7 359.13c2.01 0 3.97.25 5.9.293-22.54 68.418-67.79 140.38-151.15 206.7-196.7 156.49-298.95 312.7-204.24 557.01 4.961 12.95 11.008 26.25 17.265 39.76 1.086 2.42 2.149 5.01 3.282 7.57 32.929 71.86 82.364 143.6 112.6 187.55.72 1.02 1.46 2.03 2.08 2.96-14.2-12.1-131.46-113.16-209.04-219.91-142.78-196.48-103.44-467.96 59.18-636.4 118.93-123.15 257.99-148.48 364.12-145.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1782 1761.8c-96.74 268.44-321.79 495.17-613.65 573.4-487.85 130.61-903.14-43.67-1123-344.24 0 0 163.44-261.27 583.2-239.05 272.46 14.55 555.86-12.41 754.47-295.04 21.37-30.28 41.11-59.68 59.73-88.24 2.16-2.78 4.34-5.85 6.61-9.13 22.34-33.67 54.24-81.79 103.87-174.48 16.72-31.16 17.56-71.62-1.77-111.53-21-43.28-67.91-134.45-89.57-168.56-15.43-24.41-51.92-62.989-98.14-66.989-.22-.019-.42-.019-.63-.082 163.48 8.852 297.46 111.82 384.94 267.96 103.28 184.47 112.88 437.13 33.98 655.98z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1594.2 1652.7c-92.93 170.37-309.06 369.68-683.17 369.68-526.15 0-807.62-395.15-807.62-779.51 0-304.49 165.22-606.94 482.87-751.4-114.9 466.1 90.918 885.2 567.82 914.87 2.08.23 4.05.45 6.14.68 49.52 4.16 167.75 1.53 199.44-.87 45.9-3.72 65.92-11.16 89.6-46.65 22.34-33.67 54.24-81.85 103.87-174.51 16.72-31.13 17.56-71.59-1.77-111.5-18.31-37.8-56.31-111.78-80.1-152.82 5.1 5.918 115.98 135.9 150 220.97 80.58 201.26 21.74 421.66-27.09 511.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1363.1 837.67c163.48 8.957 297.46 112.01 384.94 268.15 103.28 184.47 112.88 437.13 33.98 655.98-36.15 100.21-90.17 194.65-158.89 277.66-26.89-77.17-33.63-174.42-19.14-299.72 34.1-235.2 14.16-434.85-20.78-569.52-7.46-28.91-14.84-52.05-22.44-72.3-2.29-8.12-5.35-16.27-9.33-24.51-21-43.31-67.91-134.37-89.57-168.48-15.43-24.41-51.98-63.141-98.14-67.008z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1621.3 1141.6c80.58 201.26 21.74 421.66-27.09 511.06-92.93 170.37-309.06 369.68-683.17 369.68-254.14 0-451.21-92.22-586.99-230.85 81.172-28.3 181.78-46.01 304.43-39.62 272.46 14.55 555.86-12.41 754.47-295.04 21.37-30.28 41.11-59.68 59.73-88.24h.01c1.08-1.32 2.1-2.72 3.16-4.12 1.08-1.64 2.28-3.4 3.44-5.01 22.34-33.67 54.24-81.85 103.87-174.51 16.72-31.13 17.56-71.59-1.77-111.5-18.31-37.8-56.31-111.78-80.1-152.82 5.1 5.918 115.98 135.9 150 220.97z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1928.8 748.6c-67.15 44.75-106.02 141.61-102.62 235.64 3.71 101.81-56.78 85.792-56.78 85.792s-125.56-229.92-413.33-232.36h-.24c-52.47.387-143.71 3.816-182.01 4.156-183.97-1.898-363.25-37.207-508.64-221.51 0 0 153.74 8.36 455.42-84.57 560.17-172.56 837.17 151.51 808.2 212.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1769.4 1070.2s-124.42-227.68-409.23-232.29c-1.55-.187-3.17-.289-4.81-.187-14.43 0-33.96.449-54.94 1.047-47.21 1.133-99.83 2.812-126.6 3.109-9.98-.117-19.92-.34-29.89-.668-16.04-.621-31.93-1.441-40.33-1.832-2.07-.238-4.04-.387-6.05-.609 70.84-76.149 194.74-145.6 361.89-147.26 124.62-1.289 265.38 34.187 400.04 130.7 1.05.719 1.88 1.481 2.87 2.149-25.28 46.461-38.21 103.82-36.17 159.93 3.71 101.81-56.78 85.912-56.78 85.912z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1652.5 517.57c-63.93 187.77-245.64 291.4-462.32 319.73-14.28 1.89-27.5 2.98-39.5 4.187-175.82-4.918-346.19-44.609-485.51-221.17 0 0 153.74 8.36 455.42-84.57 222.44-68.488 400.17-58.711 531.91-18.18z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M267.593 9.545c-25.064 7.498-41.601 17.726-48.534 37.617-16.005-19.35-37.754-34.256-63.147-41.057C88.187-12.035 30.525 12.159-.004 53.895c0 0 11.388 18.153 38.69 27.682-20.18 20.604-30.629 48.587-30.629 76.17 0 42.28 22.94 84.27 67.05 104.327-.022-.052-.025-.096-.037-.147.012.035.015.069.036.1a136.723 136.723 0 0 0 5.948 14.179c29.411 60.443 87.94 46.67 87.94 46.67s10.495-19.86 3.058-42.483c26.742-1.135 51.072-21.944 51.072-21.944l-.003-.003c27.76-8.56 40.776-26.942 38.358-32.075-3.747-2.5-6.852-6.181-9.2-10.52C319.644 166.973 302.803 43.43 267.588 9.55M667.463 122.182v107.041c0 .8-.312 1.555-.888 2.123a3.056 3.056 0 0 1-2.09.852l-25.068.03s.156-44.114 0-52.898c-.109-5.79 1.695-23.485 2.344-26.471.003-.024.003-.124.015-.202-.099-.462-.49-.328-.604-.248a1.217 1.217 0 0 0-.143.156l-28.436 45.873a3.444 3.444 0 0 1-.579.817c-.55.56-1.312.862-2.112.862l-6.986-.02h-.015l-7 .02a2.988 2.988 0 0 1-2.113-.862 3.93 3.93 0 0 1-.568-.817l-28.435-45.873s-.09-.113-.138-.156c-.122-.08-.512-.214-.61.248 0 .078 0 .178.008.202.65 2.986 2.457 20.682 2.348 26.471-.156 8.784 0 52.899 0 52.899l-25.065-.031a3.067 3.067 0 0 1-2.097-.852 2.971 2.971 0 0 1-.895-2.123V122.182c0-1.632 1.35-2.958 2.992-2.958h30.279c1.26 0 2.241.654 2.89 1.696 0 0 21.404 36.834 23.96 41.237 1.639 2.796 4.068 9.302 4.057 9.691V171.903h.01c.02.193.17.339.368.345h.023a.381.381 0 0 0 .37-.345h.016V171.848c-.016-.389 2.416-6.895 4.041-9.691l23.966-41.237c.656-1.042 1.635-1.696 2.896-1.696h30.28c1.638 0 2.98 1.326 2.98 2.958zm-179.742 40.152c-.512-.16-.97-.301-1.37-.44-8.015-2.688-14.603-6.784-14.917-12.302-.162-2.99.922-5.657 2.478-7.317 2.257-2.382 6.35-3.311 8.916-3.311 12.62 0 24.349 5.982 24.349 5.982l6.947-18.583c.248-.745.226-1.577-.102-2.281a3.02 3.02 0 0 0-1.717-1.556l-.147-.044c-6.08-2.28-17.049-5.643-29.663-5.833-24.5-.332-39.207 12.107-39.207 32.37 0 23.91 20.162 31.69 26.788 34.375 1.135.473 2.383.95 3.692 1.449 4.393 1.66 9.259 3.736 12.965 6.04 4.05 2.524 4.917 7.175 4.277 10.231-1.84 8.83-11.53 10.737-19.276 9.573-14.772-2.209-22.523-6.302-22.523-6.302l-6.34 18.74a2.992 2.992 0 0 0 1.407 3.573c.119.067 13.656 6.921 31.005 6.921 19.84 0 42.999-9.445 42.999-36.135 0-24.554-21.28-32.198-30.56-35.15zm-119.666 46.928c-9.613.42-15.55-.242-18.301-1.054l.016-65.452c3.033-.476 9.924-1.105 19.095-.763 11.456.44 30.694 4.501 30.694 30.635 0 27.242-19.636 36.12-31.504 36.634zm29.747-85.27c-16.036-7.066-35.515-7.51-46.443-7.066-22.574.886-29.672 2.833-29.672 2.833v108.365c0 1.305.818 2.456 2.016 2.86.06.026 10.202 3.034 27.858 3.51 22.715.595 39.297-2.422 51.665-10.697 16.6-11.11 24.778-26.906 24.778-50.005 0-24.212-10.156-40.97-30.202-49.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1972.8 2310.4c-277.75-83.11-410.25-212.51-368.81-570.64 34.1-235.2 14.16-434.83-20.78-569.56-7.46-28.89-14.84-52.05-22.44-72.2-2.29-8.17-5.35-16.37-9.33-24.53-21-43.28-67.91-134.45-89.57-168.56-16.3-25.86-56.34-67.809-106.51-67.36-48.64.371-154.92 4.258-182.5 4.258-26.43 0-75.41-3.008-75.41-3.008 70.84-76.25 194.81-145.7 361.99-147.36 124.62-1.289 265.38 34.059 400.04 130.7 488.88 350.55 367.5 1243.7 113.32 1488.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M956.35 1446.6c-343.54-107.64-521.49-530.72-370.02-954.88 12.129-34.121 26.348-68.128 42.891-102.13 211.81-435.31 633.38-336.11 633.38-336.11s152.56 288.61-129.14 512.63c-196.7 156.49-298.95 312.7-204.24 557.01 5 12.95 11.008 26.32 17.363 39.82 1.027 2.38 2.051 4.95 3.301 7.51 32.812 71.86 82.207 143.6 112.49 187.64 20.54 29.81 44.63 44.4 97.92 48.92 49.52 4.16 167.75 1.53 199.44-.87 45.9-3.72 65.92-11.16 89.6-46.65.53-.92 1.1-1.72 1.69-2.62-67.8 126.11-285.63 155.19-494.67 89.73"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1190.2 837.3c-35.77 4.758-65.41 4.488-83.95 11.578l-.16.23c-16.22 6.063-31.38 16.922-44.37 36.012-29.45 43.32-87.813 143.54-108.16 185.07-21.98 44.74-19.988 64.7-3.769 100.27 32.929 71.86 82.364 143.6 112.6 187.55.72 1.02 1.46 2.11 2.14 3.05-14.26-12.19-131.52-113.25-209.1-220-142.78-196.48-103.44-467.96 59.18-636.4 118.93-123.15 257.99-148.48 364.12-145.53 194.91 5.351 373.79 158.44 373.79 158.44-63.89 187.77-245.61 291.4-462.32 319.73"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1278.7 359.13c2.01 0 3.97.25 5.9.293-22.54 68.418-67.79 140.38-151.15 206.7-196.7 156.49-298.95 312.7-204.24 557.01 4.961 12.95 11.008 26.25 17.265 39.76 1.086 2.42 2.149 5.01 3.282 7.57 32.929 71.86 82.364 143.6 112.6 187.55.72 1.02 1.46 2.03 2.08 2.96-14.2-12.1-131.46-113.16-209.04-219.91-142.78-196.48-103.44-467.96 59.18-636.4 118.93-123.15 257.99-148.48 364.12-145.53"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1782 1761.8c-96.74 268.44-321.79 495.17-613.65 573.4-487.85 130.61-903.14-43.67-1123-344.24 0 0 163.44-261.27 583.2-239.05 272.46 14.55 555.86-12.41 754.47-295.04 21.37-30.28 41.11-59.68 59.73-88.24 2.16-2.78 4.34-5.85 6.61-9.13 22.34-33.67 54.24-81.79 103.87-174.48 16.72-31.16 17.56-71.62-1.77-111.53-21-43.28-67.91-134.45-89.57-168.56-15.43-24.41-51.92-62.989-98.14-66.989-.22-.019-.42-.019-.63-.082 163.48 8.852 297.46 111.82 384.94 267.96 103.28 184.47 112.88 437.13 33.98 655.98"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1594.2 1652.7c-92.93 170.37-309.06 369.68-683.17 369.68-526.15 0-807.62-395.15-807.62-779.51 0-304.49 165.22-606.94 482.87-751.4-114.9 466.1 90.918 885.2 567.82 914.87 2.08.23 4.05.45 6.14.68 49.52 4.16 167.75 1.53 199.44-.87 45.9-3.72 65.92-11.16 89.6-46.65 22.34-33.67 54.24-81.85 103.87-174.51 16.72-31.13 17.56-71.59-1.77-111.5-18.31-37.8-56.31-111.78-80.1-152.82 5.1 5.918 115.98 135.9 150 220.97 80.58 201.26 21.74 421.66-27.09 511.06"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M1363.1 837.67c163.48 8.957 297.46 112.01 384.94 268.15 103.28 184.47 112.88 437.13 33.98 655.98-36.15 100.21-90.17 194.65-158.89 277.66-26.89-77.17-33.63-174.42-19.14-299.72 34.1-235.2 14.16-434.85-20.78-569.52-7.46-28.91-14.84-52.05-22.44-72.3-2.29-8.12-5.35-16.27-9.33-24.51-21-43.31-67.91-134.37-89.57-168.48-15.43-24.41-51.98-63.141-98.14-67.008l-.63-.25"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M1621.3 1141.6c80.58 201.26 21.74 421.66-27.09 511.06-92.93 170.37-309.06 369.68-683.17 369.68-254.14 0-451.21-92.22-586.99-230.85 81.172-28.3 181.78-46.01 304.43-39.62 272.46 14.55 555.86-12.41 754.47-295.04 21.37-30.28 41.11-59.68 59.73-88.24h.01c1.08-1.32 2.1-2.72 3.16-4.12 1.08-1.64 2.28-3.4 3.44-5.01 22.34-33.67 54.24-81.85 103.87-174.51 16.72-31.13 17.56-71.59-1.77-111.5-18.31-37.8-56.31-111.78-80.1-152.82 5.1 5.918 115.98 135.9 150 220.97"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M1928.8 748.6c-67.15 44.75-106.02 141.61-102.62 235.64 3.71 101.81-56.78 85.792-56.78 85.792s-125.56-229.92-413.33-232.36h-.24c-52.47.387-143.71 3.816-182.01 4.156-183.97-1.898-363.25-37.207-508.64-221.51 0 0 153.74 8.36 455.42-84.57 560.17-172.56 837.17 151.51 808.2 212.85"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M1769.4 1070.2s-124.42-227.68-409.23-232.29c-1.55-.187-3.17-.289-4.81-.187-14.43 0-33.96.449-54.94 1.047-47.21 1.133-99.83 2.812-126.6 3.109-9.98-.117-19.92-.34-29.89-.668-16.04-.621-31.93-1.441-40.33-1.832-2.07-.238-4.04-.387-6.05-.609 70.84-76.149 194.74-145.6 361.89-147.26 124.62-1.289 265.38 34.187 400.04 130.7 1.05.719 1.88 1.481 2.87 2.149-25.28 46.461-38.21 103.82-36.17 159.93 3.71 101.81-56.78 85.912-56.78 85.912"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d3a82",
    d: "M127.51 131.355c-45.804 14.351-69.53 70.76-49.335 127.32-15.314-62.135 12.128-117.995 75.708-121.951l.818-.09c6.603-.555 22.367-.205 26.592.115 6.12.496 8.789 1.488 11.946 6.22.07.123.147.23.225.35-9.04-16.815-38.083-20.692-65.954-11.964"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "matrix(.1333 0 0 -.1333 0 324.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M1652.5 517.57c-63.93 187.77-245.64 291.4-462.32 319.73-14.28 1.89-27.5 2.98-39.5 4.187-175.82-4.918-346.19-44.609-485.51-221.17 0 0 153.74 8.36 455.42-84.57 222.44-68.488 400.17-58.711 531.91-18.18"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#193373",
    d: "M215.781 111.075c1.422 23.177-1 42.88-4.696 57.128-.994 3.855-1.978 6.94-2.992 9.627 0 0-.008.036-.008.049-.14.488-.3.98-.486 1.464-.039.11-.08.2-.126.307-.16.43-.346.857-.546 1.277a3.381 3.381 0 0 1-.078.173c-2.44 5.04-7.493 14.883-10.663 20.361.798-.941 15.473-18.151 19.983-29.447 8.977-22.444 4.97-46.634-.388-60.939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#512988",
    d: "M158.33 255.298c-2.123-2.21-4.949-4.425-7.626-6.549-12.846-10.224-22.254-20.414-27.45-32.002-12.424 4.123-24.56 11.57-34.975 24.776 0 0 20.489-1.115 60.715 11.275 3.025.93 6.427 1.765 9.335 2.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#50276c",
    d: "M156.503 211.989c3.569.04 10.585.263 16.869.42-6.635-.167-14.405-.42-16.997-.42-.855 0-1.914.015-2.998.045.032 0 .066 0 .1.017 1.006-.023 2.018-.047 3.026-.062M181.235 212.543H180.774c-2.11-.024-4.69-.066-7.398-.134 2.808.075 5.412.134 7.335.148.18 0 .352-.014.524-.014M146.33 212.403c.268-.03.53-.049.806-.062-.504.027-.82.049-.82.049l.014.013"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#50276c",
    d: "M146.33 212.403c.268-.03.53-.049.806-.062-.504.027-.82.049-.82.049l.014.013M153.476 212.051c-.033-.017-.067-.017-.099-.017-.29.017-.577.028-.86.044.32-.016.65-.016.96-.027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#50276c",
    d: "M153.476 212.051c-.033-.017-.067-.017-.099-.017-.29.017-.577.028-.86.044.32-.016.65-.016.96-.027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#50276c",
    d: "M153.476 212.051c-.31.01-.64.01-.958.027-1.8.052-3.59.14-5.378.263-.276.013-.538.033-.806.062 9.45 10.153 25.964 19.413 48.25 19.635a78.86 78.86 0 0 0 9.923-.49c-11.71-10.38-27.863-16.608-45.822-18.955-1.878-.252-3.622-.397-5.209-.541"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#50276c",
    d: "M153.476 212.051c-.31.01-.64.01-.958.027-1.8.052-3.59.14-5.378.263-.276.013-.596.03-.866.054 9.453 10.154 26.024 19.421 48.31 19.642a78.86 78.86 0 0 0 9.923-.489c-11.71-10.38-27.863-16.609-45.822-18.955-1.878-.252-3.622-.398-5.209-.541"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#67268e",
    d: "M153.476 212.051c-.31.01-.64.01-.958.027-1.8.052-3.59.14-5.378.263-.276.013-.596.03-.866.054 9.453 10.154 26.024 19.421 48.31 19.642a78.86 78.86 0 0 0 9.923-.489c-11.71-10.38-27.863-16.609-45.822-18.955-1.878-.252-3.622-.398-5.209-.541"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsmSimplifiedLogoReversed);
export default __webpack_public_path__ + "static/media/DSM_SimplifiedLogo_Reversed.368ea551e3a4d5092736e50d5728670c.svg";
export { ForwardRef as ReactComponent };